// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Transfer money via PESONet'"></sub-header>
  <form-section>

    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.depositAccount.productName}}</span>
      </div>

      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.depositAccount.balance > 0, 'currency--negative': \$ctrl.depositAccount.balance < 0}">
            {{\$ctrl.depositAccount.balance | nxCurrency}}
          </span>
      </div>
    </div>

    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table table--generate-row-ids">
      <tr>
        <td></td>
        <td class="param-label">Pesonet bank name:</td>
        <td class="param-value">
          <selectize
            config="\$ctrl.config"
            options="\$ctrl.pesonetBanks"
            ng-model="\$ctrl.bankCode"
            required>
          </selectize>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="param-label">Account number:</td>
        <td class="param-value">
          <input type="text"
                 ng-model="\$ctrl.accountNumber"
                 pattern="^[0-9]+\$"
                 maxlength="35"
                 required
                 name="accountNumber"
          />
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="param-label">Account name:</td>
        <td class="param-value">
          <input type="text"
                 ng-model="\$ctrl.accountName"
                 name="accountName"
                 required
          />
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="param-label">Amount:</td>
        <td class="param-value">
          <cash ng-if="\$ctrl.depositAccount"
                ng-model="\$ctrl.amount"
                ng-required="true"
                min="0.01"
                max="\$ctrl.depositAccount.balance"
          ></cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="param-label">Remarks:</td>
        <td class="param-value">
          <input id="remarks"
                 type="text"
                 ng-model="\$ctrl.remarks"
                 name="remarks"
          />
        </td>
      </tr>
        <tr>
          <td></td>
          <td class="param-label">Category purpose:</td>
          <td class="param-value">
            <select
              ng-model="\$ctrl.categoryPurposeCode"
              ng-options="code for code in \$ctrl.categoryPurposeCodes">
            </select>
          </td>
        </tr>
    </table>
    </form>

    <div class="flex-end">
      <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()" type="button">Cancel</button>
      <button class="btn btn-danger"
              ng-disabled="\$ctrl.transactionForm.\$invalid"
              ng-click="\$ctrl.transfer()" type="button">Transfer</button>
    </div>
  </form-section>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/pesonet-transfer/pesonet-transfer.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;